import { AspectRatio, Button, Link, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalOverlay, Stack, useColorMode, useDisclosure } from '@chakra-ui/react'
import React from 'react'
import { FiDownload, FiExternalLink, FiFileText } from "react-icons/fi"
import { getTokens } from '../../config/colorTokens'

const ResumeButton = (props) => {
    const { colorMode } = useColorMode()
    const { isOpen, onOpen, onClose } = useDisclosure()
    const t = getTokens(colorMode)

    return (
        <>
            <Modal
                closeOnOverlayClick={false}
                scrollBehavior='inside'
                onClose={onClose}
                isOpen={isOpen}
                isCentered
                motionPreset="slideInBottom"
                size={{ lg: "3xl" }}
            >
                <ModalOverlay
                    backdropFilter='blur(3px)' />
                <ModalContent bg={t.modalBg}>
                    <ModalCloseButton />
                    <ModalBody>
                        <Stack>
                            <AspectRatio height="70vh" mt={10}>
                                <iframe title="Resume" src="https://drive.google.com/file/d/1GspiR7an2CgK1jM-ttdV2lHlfhtsYEHx/preview" />
                            </AspectRatio>

                        </Stack>
                    </ModalBody>
                    <ModalFooter justifyContent="center" width="100%">
                        <Button
                            width="full"
                            border="1px"
                            borderRadius="8px"
                            onClick={onOpen}
                            borderColor={t.borderCard}
                            as={Link}
                            href={"https://drive.google.com/file/d/1GspiR7an2CgK1jM-ttdV2lHlfhtsYEHx/view"}
                            target="_blank"
                            // bg={colorMode === "dark" ? "#2c313d" : "#CACBCD"}
                            bg="none"
                            leftIcon={<FiExternalLink />}
                            mr={2}
                            _hover={{
                                textDecoration: "none",
                                bg: t.hoverBg,
                            }} >
                            Open
                        </Button>
                        <Button
                            width="full"
                            border="1px"
                            borderRadius="8px"
                            onClick={onOpen}
                            borderColor={t.borderCard}
                            as={Link}
                            href={"https://drive.google.com/uc?export=download&id=1GspiR7an2CgK1jM-ttdV2lHlfhtsYEHx"}
                            target="_blank"
                            // bg={colorMode === "dark" ? "#2c313d" : "#CACBCD"}
                            bg="none"
                            ml={2}
                            leftIcon={<FiDownload />}
                            _hover={{
                                textDecoration: "none",
                                bg: t.hoverBg,
                            }}
                        >
                            Download
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <Button
                border="1px"
                borderRadius="8px"
                onClick={onOpen}
                borderColor={t.borderCard}
                // as={Link}
                // href={"https://drive.google.com/file/d/1GspiR7an2CgK1jM-ttdV2lHlfhtsYEHx/view"}
                target="_blank"
                // bg={colorMode === "dark" ? "#2c313d" : "#CACBCD"}
                bg={t.surfaceAlpha}
                h="42px"
                px={5}
                fontWeight="medium"
                backdropFilter={"blur(18px)"}
                _hover={{
                    textDecoration: "none",
                    bg: t.hoverBg,
                    borderColor: t.accent,
                }}
                leftIcon={<FiFileText />}>
                Resume
            </Button>
        </>
    )
}

export default ResumeButton
